import PermissionLink from '../../components/PermissionLink';
import React, { useState } from 'react';
import { CapType } from '../../api/captype';
import { CapDevicesModal, ClickableCapBadge, useCapTypes } from '../../components/CapTypeBadges';
import HelpTip from '../../components/HelpTip';
import DeviceCapTypeBindModal from './DeviceCapTypeBindModal';
import { useCan } from '../../store';

// 设备工况 › 具备工艺类型 (2026-09-08): 工艺类型 → 设备显式绑定 (cap_type.deviceKeys) 的反向视图,
// 「维护绑定」在本页弹窗勾选 (写的还是 cap_type.deviceKeys 同一份数据); 徽标点开复用"具备该工艺的设备"弹层.
// 全站工艺类型共用 useCapTypes 的模块级缓存, 保存后缓存失效自动重拉.

function DeviceCapTypesCard({ deviceKey, deviceName }: { deviceKey: string; deviceName: string }) {
    const canUpdate = useCan('device', 'update');
    const { capTypes, loaded } = useCapTypes();
    const [openCap, setOpenCap] = useState<CapType | null>(null);
    const [editing, setEditing] = useState(false);
    const mine = capTypes.filter((c) => (c.deviceKeys || []).includes(deviceKey));

    return (
        <div className="card p-4 col-span-3">
            <div className="flex items-center justify-between mb-2">
                <div className="text-sm font-semibold flex items-center gap-1.5">
                    具备工艺类型
                    <HelpTip text="工艺类型管理里显式绑定到本设备的工艺 (不按光源推断)。材料/SKU 的适配工艺类型徽标由同一份工艺类型驱动。" />
                    <span className="text-xs text-slate-400 font-normal">{mine.length} 项</span>
                </div>
                <div className="flex items-center gap-3 text-xs">
                    <button
                        type="button"
                        className="text-brand-600 hover:underline"
                        onClick={() => setEditing(true)} hidden={!canUpdate}>
                        ✎ 维护绑定
                    </button>
                    <PermissionLink resource="cap_type" verb="update" hide
                        to="/admin/data-dict?d=crafttype"
                        className="text-slate-400 hover:text-slate-600"
                        title="到「数据字典 · 工艺类型」按工艺类型批量绑设备"
                    >
                        工艺类型管理 →
                    </PermissionLink>
                </div>
            </div>
            {!loaded && <div className="text-xs text-slate-400">加载中…</div>}
            {loaded && mine.length === 0 && (
                <div className="text-xs text-slate-400">尚未绑定到任何工艺类型, 点右上角「维护绑定」勾选。</div>
            )}
            {mine.length > 0 && (
                <div className="flex flex-wrap gap-1">
                    {mine.map((c) => (
                        <ClickableCapBadge key={c.capKey} cap={c} enabled onOpen={setOpenCap} />
                    ))}
                </div>
            )}
            <CapDevicesModal cap={openCap} onClose={() => setOpenCap(null)} />
            <DeviceCapTypeBindModal
                open={editing}
                deviceKey={deviceKey}
                deviceName={deviceName}
                capTypes={capTypes}
                onClose={() => setEditing(false)}
            />
        </div>
    );
}

export default DeviceCapTypesCard;
